(() => {
  'use strict';
  // Request context only: a handle expresses a preference, never an assignment.
  const slot = '__bdPoolContactContextV2';
  if (window[slot]) { window[slot].refresh(); return; }
  const states = new WeakMap();
  const names = {person: 'contact[Gewünschte Profilkennung]', product: 'contact[Produkt]'};
  const handle = value => /^[a-z0-9][a-z0-9-]{0,127}$/.test(value);
  const topicText = value => value.length <= 160 && !/[<>\u0000-\u001f\u007f-\u009f\u202a-\u202e\u2066-\u2069]/.test(value);
  function uniqueValue(params, aliases, valid) {
    const values = aliases.flatMap(key => params.getAll(key));
    if (values.length !== 1) return '';
    const value = values[0].trim();
    return value && valid(value) ? value : '';
  }
  function readContext() {
    const params = new URLSearchParams(location.search);
    return {
      person: uniqueValue(params, ['person'], handle),
      product: uniqueValue(params, ['product', 'produkt'], handle),
      topic: uniqueValue(params, ['thema', 'anliegen'], topicText)
    };
  }
  function bind(form) {
    let state = states.get(form);
    if (state) return state;
    const select = form.elements.namedItem('contact[Thema]');
    state = {signature: null, initialTopic: select?.value || '', force: true};
    states.set(form, state);
    form.addEventListener('reset', () => {
      queueMicrotask(() => { state.force = true; refreshForm(form); });
    });
    // Recheck the outgoing preference fields; DOM readonly is not an authority.
    form.addEventListener('formdata', event => {
      const context = readContext();
      for (const field of ['person', 'product']) {
        event.formData.delete(names[field]);
        if (context[field]) event.formData.set(names[field], context[field]);
      }
    });
    return state;
  }
  function refreshForm(form) {
    const state = bind(form), context = readContext();
    for (const field of ['person', 'product']) {
      const input = form.querySelector(field === 'person' ? '[data-pool-person]' : '[data-contact-product]');
      const wrap = form.querySelector(field === 'person' ? '[data-pool-person-wrap]' : '[data-contact-product-wrap]');
      if (input) { input.value = context[field]; input.disabled = !context[field]; }
      if (wrap) wrap.hidden = !context[field];
    }
    const signature = JSON.stringify(context);
    const select = form.elements.namedItem('contact[Thema]');
    if (select && (state.force || state.signature !== signature)) {
      select.querySelectorAll('option[data-pool-context]').forEach(option => option.remove());
      select.value = state.initialTopic;
      if (context.topic) {
        let option = [...select.options].find(item => item.value === context.topic || item.text === context.topic);
        if (!option) {
          option = document.createElement('option'); option.dataset.poolContext = 'true';
          option.value = context.topic; option.textContent = context.topic; select.add(option);
        }
        select.value = option.value;
      }
      state.signature = signature; state.force = false;
    }
    for (const [name, max] of [['contact[name]',160],['contact[email]',254],['contact[phone]',40],['contact[body]',4000]]) {
      const input = form.elements.namedItem(name); if (input) input.maxLength = max;
    }
  }
  function refresh() { document.querySelectorAll('.contact-form').forEach(refreshForm); }
  window[slot] = Object.freeze({refresh});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true});
  else refresh();
  addEventListener('popstate', refresh);
  addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
